import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalAccountListDocument = gql`
  query SalesPortalAccountList($businessOrganizationUUID: uuid!) {
    getSalesPortalAccounts(
      business_organization_id: $businessOrganizationUUID
    ) {
      chat_id
      currency_code
      restaurant_id
      supplier_id
      restaurant {
        name
        address {
          address
        }
      }
    }
  }
`;
export function useSalesPortalAccountListQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalAccountListQuery,
    Types.SalesPortalAccountListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalAccountListQuery,
    Types.SalesPortalAccountListQueryVariables
  >(SalesPortalAccountListDocument, options);
}
export function useSalesPortalAccountListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalAccountListQuery,
    Types.SalesPortalAccountListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalAccountListQuery,
    Types.SalesPortalAccountListQueryVariables
  >(SalesPortalAccountListDocument, options);
}
export type SalesPortalAccountListQueryHookResult = ReturnType<
  typeof useSalesPortalAccountListQuery
>;
export type SalesPortalAccountListLazyQueryHookResult = ReturnType<
  typeof useSalesPortalAccountListLazyQuery
>;
export type SalesPortalAccountListQueryResult = Apollo.QueryResult<
  Types.SalesPortalAccountListQuery,
  Types.SalesPortalAccountListQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalAccountListQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalAccountListQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalAccountListQuery,
    Types.SalesPortalAccountListQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalAccountListQuery,
    Types.SalesPortalAccountListQueryVariables
  >(SalesPortalAccountListDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalAccountListLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalAccountListLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalAccountListQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalAccountListQuery,
    Types.SalesPortalAccountListQueryVariables
  >(SalesPortalAccountListDocument, lazyOptions);
}
